import { render, staticRenderFns } from "./ArticleRowItem.vue?vue&type=template&id=16141898&"
import script from "./ArticleRowItem.vue?vue&type=script&lang=js&"
export * from "./ArticleRowItem.vue?vue&type=script&lang=js&"
import style0 from "./ArticleRowItem.vue?vue&type=style&index=0&id=16141898&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports